import React from 'react';

interface CardProps {
  /**
   * Card content
   */
  children: React.ReactNode;
  /**
   * Optional CSS class to add
   */
  className?: string;
  /**
   * Whether to add hover effects
   */
  hover?: boolean;
  /**
   * Whether to add padding
   */
  padding?: boolean;
  /**
   * Whether to add margin bottom
   */
  marginBottom?: boolean;
}

/**
 * Card component for containing content with consistent styling
 */
const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  padding = false,
  marginBottom = false,
  ...props
}) => {
  // Base classes
  const baseClasses = 'card';
  
  // Hover classes
  const hoverClasses = hover ? 'card-hover' : '';
  
  // Padding classes
  const paddingClasses = padding ? 'p-4 md:p-6' : '';
  
  // Margin classes
  const marginClasses = marginBottom ? 'mb-6' : '';
  
  // Combine all classes
  const cardClasses = [
    baseClasses,
    hoverClasses,
    paddingClasses,
    marginClasses,
    className,
  ].filter(Boolean).join(' ');
  
  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export default Card;